module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--confirm"
  }, [_c('div', {
    staticClass: "group group--sidebar group--df group--flex mw1920"
  }, [_c('div', {
    staticClass: "group--flex confirm__bg"
  }, [_c('h1', {
    staticClass: "h1 mw600",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.confirmMessage)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p mw600"
  }, [_vm._v(_vm._s(_vm.confirmDescription))]), _vm._v(" "), (_vm.confirmButtonLink) ? _c('module-button', {
    staticClass: "mw220",
    attrs: {
      "button": "primary",
      "link": _vm.link
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.confirmButtonAction) ? _c('module-button', {
    staticClass: "mw300",
    attrs: {
      "button": "primary",
      "type": "button",
      "loading": _vm.isLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.triggerAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('img', {
    staticClass: "confirm__image",
    attrs: {
      "src": _vm.image,
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ec0f575"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/base/Confirm.vue
// module id = 413
// module chunks = 0